import BinaryOrb from '@/components/portal/0Logic/BinaryOrb';
import { useLang } from '@/lib/LanguageContext';

const STATS = [['24/7', 'Monitoring'], ['Live', 'Threat Detection'], ['AI', 'Powered Defense']];

export default function ZeroLogicSection() {
  const { t } = useLang();
  return (
    <section className="py-24 px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-background" />
      <div className="max-w-6xl mx-auto relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <BinaryOrb status="idle" size={48} />
              <span className="text-sm font-medium text-primary uppercase tracking-wider">{t('Powered by 0Logic AI')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-foreground leading-tight">
              {t('Site Protected by')}<br />
              <span className="text-primary">0Logic AI SSS</span>
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              {t('Advanced AI-powered threat detection, real-time vulnerability scanning, and autonomous attack blocking. Our cybersecurity AI continuously monitors and protects this platform against emerging threats.')}
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              <a href="https://0logic.ai" target="_blank" rel="noopener noreferrer"
                className="px-8 py-4 bg-primary text-primary-foreground rounded-xl font-semibold hover:bg-primary/90 transition-all shadow-lg shadow-primary/25 hover:shadow-primary/40">
                {t('Learn More About 0Logic AI')}
              </a>
            </div>
            <div className="grid grid-cols-3 gap-6 pt-8">
              {STATS.map(([v, l]) => (
                <div key={l} className="text-center">
                  <div className="text-3xl font-bold text-primary mb-1">{v}</div>
                  <div className="text-xs text-muted-foreground">{t(l)}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative flex items-center justify-center">
            <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-transparent to-primary/20 blur-3xl" />
            <img src="https://media.base44.com/images/public/69f7328a281ea086a55ced65/73b9f10bd_generated_image.png"
              alt={t('0Logic AI cybersecurity dashboard')} loading="lazy" decoding="async"
              className="relative w-full max-w-md rounded-2xl shadow-2xl shadow-primary/20 border border-primary/20" />
          </div>
        </div>
      </div>
    </section>
  );
}